import React, {useState, useEffect} from 'react';
import toastr from 'toastr';
import {
  CardBody,
  Col,
  Row,
  Spinner, Tooltip,
  Popover, PopoverBody, UncontrolledTooltip
} from "reactstrap";
import CardItem from 'components/PurpleTheme/CardItem';
import {Link} from 'react-router-dom';
import {
  getStateSpecificAWSLogo as getAWSLogo,
  getStateSpecificNRLogo as getNRLogo,
  getStateSpecificGCPLogo as getGCPLogo,
  getStateSpecificDatadogLogo as getDatadogLogo,
  getStateSpecificAzureLogo as getAzureLogo,
  getAppDynamicsLogo,
  getNRDisplayName,
  getDatadogName,
  getAzureDisplayName,
  getAlertHealth,
  getMissingAlertsDisplay,
  getStateSpecificSplunkLogo,
  getSplunkName,
  getAppDynamicsName,
  getDynatraceName,
  getDynatraceLogo,
  getOciLogo,
  getOciName,
  getGrafanaLogo,
  getGrafanaName,
  getSignozLogo, getSignozName
} from "../../helpers/component_helpers";

import {datadog_resources as DATADOG_RESOURCES} from '../../constants/data_types'
import "./style.scss";

const TableRow = ({
                    type,
                    isLoading,
                    checkBox,
                    filteredResources,
                    total_resources,
                    handleCheckBox,
                    getNotificationServiceMapping,
                    handleIndividualDeploy,
                    startLoading2
                  }) => {
  const [tright, settright] = useState(false);
  const [ec2IgnoredTooltip, setEc2IgnoredTooltip] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [popoverText, setPopoverText] = useState('');
  const [typePopoverOpen, setTypePopoverOpen] = useState({});
  const [typePopoverText, setTypePopoverText] = useState({});
  const [iconPopoverOpen, setIconPopoverOpen] = useState({});
  const [iconPopoverText, setIconPopoverText] = useState('');
  const [environmentPopoverText, setEnvironmentPopoverText] = useState({});
  const [environmentPopoverOpen, setEnvironmentPopoverOpen] = useState({});
  const [regionPopoverOpen, setRegionPopoverOpen] = useState({});
  const [cloudIdPopoverOpen, setCloudIdPopoverOpen] = useState({});
  const [cloudIdPopoverText, setCloudIdPopoverText] = useState({});
  const [eksClusterId, setEksClusterId] = useState('');
  const resourceCount = Object.keys(filteredResources).length;
  const [regionTooltipOpen, setRegionTooltipOpen] = useState(false);

  // Copies Text to clipboard
  // If Navigator Clipboard API is available, uses that
  // Else, creates a textarea element, copies text to it,
  // selects it, and executes copy command
  const copyToClipboard = (textToCopy) => {

    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => toastr.success("Copied!"))
        .catch(err => console.error('Could not copy text: ', err));
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        toastr.success("Copied!");
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  };

  function getDatadogEndpointMethodName(data) {
    if (data === null) {
      return ""
    }
    // Load the json data
    const json_data = JSON.parse(data);
    if ("method" in json_data) {
      return json_data["method"];
    } else {
      // If the key does not exist, return an empty string
      return "";
    }
  }

  const togglePopover = (key, isOpen) => {
    setPopoverOpen(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnter = (key, name) => {
    setPopoverText(name);
    togglePopover(key, true);
  };

  const handleMouseLeave = (key) => {
    togglePopover(key, false);
  };

  const handleTypeMouseEnter = (resourceId, type) => {
    setTypePopoverText(prevState => ({
      ...prevState,
      [resourceId]: type,
    }));
    setTypePopoverOpen(prevState => ({
      ...prevState,
      [resourceId]: true,
    }));
  };

  const handleTypeMouseLeave = (resourceId) => {
    setTypePopoverOpen(prevState => ({
      ...prevState,
      [resourceId]: false,
    }));
  };

  const handleCloudIdMouseEnter = (key, name) => {
    setCloudIdPopoverText(name);
    setCloudIdPopoverOpen(prevState => ({
      ...prevState,
      [key]: true,
    }));
  };

  const handleCloudIdMouseLeave = (key) => {
    setCloudIdPopoverOpen(prevState => ({
      ...prevState,
      [key]: false,
    }));
  };

  const togglePopoverIcon = (key, isOpen) => {
    setIconPopoverOpen(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnterIcon = (key, name) => {
    setIconPopoverText(name);
    togglePopoverIcon(key, true);
  };

  const handleMouseLeaveIcon = (key) => {
    togglePopoverIcon(key, false);
  };

  const handleRegionMouseEnter = (key) => {
    setRegionPopoverOpen(prevState => ({
      ...prevState,
      [key]: true,
    }));
  };

  const handleRegionMouseLeave = (key) => {
    setRegionPopoverOpen(prevState => ({
      ...prevState,
      [key]: false,
    }));
  };

  const handleRegionTooltipOpen = (key) => {
    setRegionTooltipOpen(prevState => ({
      ...prevState,
      [key]: true,
    }));
  }

  const handleRegionTooltipClose = (key) => {
    setRegionTooltipOpen(prevState => ({
      ...prevState,
      [key]: false,
    }));
  }

  const handleEnvMouseEnter = (key, name) => {
    setEnvironmentPopoverText(name);
    setEnvironmentPopoverOpen(prevState => ({
      ...prevState,
      [key]: true,
    }));
  };

  const handleEnvMouseLeave = (key) => {
    setEnvironmentPopoverOpen(prevState => ({
      ...prevState,
      [key]: false,
    }));
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const eksClusterId = urlParams.get('eks_cluster_id');
    setEksClusterId(eksClusterId);
  }, []);

  return (
    <div>
      <div className="scrollable-container">
        {isLoading ? (
          <Spinner className="ms-2 spinner-container" color="primary"/>
        ) : (
          Object.keys(filteredResources).length === 0 ? (
            eksClusterId ? (
              <div style={{display: 'flex', justifyContent: 'center', height: '50vh', fontSize: '1em'}}>
                Please enable container insights for EKS. AWS Doc:
                <a style={{color: '#00b9ff', textDecoration: 'none', fontSize: '1em'}}
                   href="https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/deploy-container-insights-EKS.html">
                  https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/deploy-container-insights-EKS.html
                </a>
              </div>
            ) : (
              <div style={{display: 'flex', justifyContent: 'center', height: '50vh', fontSize: '1em'}}>
                No Resources Available. Please do a Resource Scan
              </div>
            )
          ) : (

            Object.keys(filteredResources).map((key, index) => (
              <CardItem key={key} className={(checkBox[key] ? 'card-border' : '')}>
                <CardBody className="pt-0 pr-2 pb-1">
                  <Row className="align-items-center">
                    <Col md="1" className="padding-t-15">
                      <div className="mb-2 text-center">
                        {checkBox[key] === true ? (
                          <i
                            className="bx bx-check-square bx-sm"
                            onClick={() => handleCheckBox(key)}
                          ></i>
                        ) : (
                          <i
                            className="bx bx-square bx-sm"
                            onClick={() => handleCheckBox(key)}
                          ></i>
                        )}
                      </div>
                    </Col>
                    <Col md="2" className="padding-t-15 align-items-start">
                      <div style={{textAlign: 'left'}}>
                        <div className="resource-logo-display align-items-center">
                          <img
                            src={type === "AWS" ? getAWSLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                : type === "GCP" ? getGCPLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                  : type === 'Azure' ? getAzureLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                    : type === "Datadog" ? getDatadogLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                      : type === "Splunk" ? getStateSpecificSplunkLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                        : type === 'AppDynamics' ? getAppDynamicsLogo(filteredResources[key].resource_name, true)
                                          : type === 'Dynatrace' ? getDynatraceLogo(filteredResources[key].resource_name, true)
                                            : type === 'OCI' ? getOciLogo(filteredResources[key].resource_name, true)
                                              : type === 'Grafana' ? getGrafanaLogo(filteredResources[key].resource_name, true)
                                                : type === 'Signoz' ? getSignozLogo(filteredResources[key].resource_name, true)
                                                  : getNRLogo(filteredResources[key].resource_name, filteredResources[key].is_application_active)}
                            className="resource-logo"
                            alt="Resource Logo"
                            style={{
                              width: `${filteredResources[key].resource_name === 'appdynamics_external_services' || filteredResources[key].resource_name === 'apm_external_services' ? "25px" : "35px"}`,
                              height: `${filteredResources[key].resource_name === 'appdynamics_external_services' || filteredResources[key].resource_name === 'apm_external_services' ? "25px" : "35px"}`,
                              marginRight: `${filteredResources[key].resource_name === 'appdynamics_external_services' || filteredResources[key].resource_name === 'apm_external_services' ? "10px" : "5px"}`
                            }}
                          />
                          <h6 className="resource-name-truncate">
                            <Link id={`resource-link-${filteredResources[key]?.id}`}
                                  to={
                                    type === "AWS" ?
                                      `/resource/${filteredResources[key]?.id}/alerts`
                                      : type === "GCP" ?
                                        `/gcp/resource/${filteredResources[key]?.id}/alerts`
                                        : type === 'Azure' ?
                                          `/azure/resource/${filteredResources[key]?.id}/alerts`
                                          : type === 'AppDynamics' ?
                                            `/appdynamics/resource/${filteredResources[key]?.id}/alerts`
                                            : type === "Datadog" ?
                                              `/datadog/resource/${filteredResources[key]?.id}/alerts`
                                              : type === "Splunk" ?
                                                `/splunk/resource/${filteredResources[key]?.id}/alerts`
                                                : type === "Dynatrace" ?
                                                  `/dynatrace/resource/${filteredResources[key]?.id}/alerts`
                                                  : type === "OCI" ?
                                                    `/oci/resource/${filteredResources[key]?.id}/alerts`
                                                   : type === "Grafana" ?
                                                      `/grafana/resource/${filteredResources[key]?.id}/alerts`
                                                      : type === "Signoz" ?
                                                        `/signoz/resource/${filteredResources[key]?.id}/alerts`
                                                          :`/newrelic/resource/${filteredResources[key]?.id}/alerts`
                                  }
                                  onMouseEnter={() => handleMouseEnter(key, filteredResources[key].name)}
                                  onMouseLeave={() => handleMouseLeave(key)}>
                              {filteredResources[key].resource_name === DATADOG_RESOURCES.REGISTERED_ENDPOINT ?
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                  <div>
                                    <div className={
                                      getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'GET' ? 'btn-soft-success' :
                                        getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'POST' ? 'btn-soft-info' :
                                          getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'PUT' ? 'btn-soft-warning' :
                                            'btn-soft-success' // default class
                                    } style={{
                                      padding: '2px',
                                      color: getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'GET' ? '#149600' :
                                        getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'POST' ? '#2489CA' :
                                          getDatadogEndpointMethodName(filteredResources[key].resource_metadata) === 'PUT' ? '#FFA500' :
                                            '#149600',
                                      fontSize: '0.8em'
                                    }}>
                                      {getDatadogEndpointMethodName(filteredResources[key].resource_metadata)}
                                    </div>
                                  </div>
                                  <div>{filteredResources[key].name}</div>
                                </div> :
                                filteredResources[key]?.name?.length > 30 ? filteredResources[key]?.name?.slice(0, 30) + "..." : filteredResources[key]?.name
                              }
                            </Link>
                            <Popover isOpen={popoverOpen[key] || false} target={`resource-link-${filteredResources[key]?.id}`} placement="top">
                              <PopoverBody>{popoverText}</PopoverBody>
                            </Popover>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              fontSize: '0.8em',
                              marginTop: '10px',
                              clear: 'both'
                            }}>
                              <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {filteredResources[key].cloud_reference_id || filteredResources[key].newrelic_reference_id || filteredResources[key].datadog_reference_id || filteredResources[key].splunk_reference_id || filteredResources[key].appdynamics_reference_id || filteredResources[key].azure_reference_id || filteredResources[key].dynatrace_reference_id || filteredResources[key].grafana_reference_id || filteredResources[key].signoz_reference_id}
                              </div>
                              <div className="copy-cloud-id" style={{marginLeft: '2px'}}>
                                <i className="bx bx-copy" style={{cursor: 'pointer', width: '15px', height: '15px'}} onClick={() => {
                                  copyToClipboard(filteredResources[key].cloud_reference_id || filteredResources[key].newrelic_reference_id || filteredResources[key].datadog_reference_id || filteredResources[key].splunk_reference_id || filteredResources[key].appdynamics_reference_id || filteredResources[key].dynatrace_reference_id || filteredResources[key].grafana_reference_id || filteredResources[key].signoz_reference_id);
                                }} id={`cloudId-${index}`}></i>
                                <UncontrolledTooltip className="tooltip-component" placement="top" target={`cloudId-${index}`}>
                                  Copy Cloud ID
                                </UncontrolledTooltip>
                              </div>
                            </div>
                          </h6>
                        </div>
                        {filteredResources[key].is_recent && (
                          <i className="badge rounded-pill badge-soft-success position-absolute"
                             style={{
                               top: '-2px', right: '57px', transform: 'translate(105%, 0)', fontStyle: 'normal', fontSize: '11px', padding: '4px 8px'
                             }}
                          >New
                          </i>
                        )}
                      </div>
                    </Col>
                    <Col md="1" className="padding-t-15">
                      <div className="mb-1 text-center resource-type-truncate">
                        <div
                          id={`type-link-${key}-${filteredResources[key]?.id}`}
                          onMouseEnter={() => handleTypeMouseEnter(filteredResources[key]?.id, filteredResources[key].resource_name)}
                          onMouseLeave={() => handleTypeMouseLeave(filteredResources[key]?.id)}
                          style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}
                        >
                          {type === "AWS" ? filteredResources[key].resource_name.replace('AWS/', '') : type === "GCP" ? filteredResources[key].resource_name : type === 'NewRelic' ? getNRDisplayName(filteredResources[key].resource_name)
                            : type === 'Azure' ? getAzureDisplayName(filteredResources[key].resource_name) : type === 'Splunk' ? getSplunkName(filteredResources[key].resource_name) : type === 'AppDynamics' ? getAppDynamicsName(filteredResources[key].resource_name)
                              : type === 'Dynatrace' ? getDynatraceName(filteredResources[key].resource_name)
                                : type === 'OCI' ? getOciName(filteredResources[key].resource_name)
                                  : type === 'Grafana' ? getGrafanaName(filteredResources[key].resource_name)
                                    : type === 'Signoz' ? getSignozName(filteredResources[key].resource_name)
                                      : getDatadogName(filteredResources[key].resource_name)}
                        </div>
                        <Popover
                          isOpen={typePopoverOpen[filteredResources[key]?.id] || false}
                          target={`type-link-${key}-${filteredResources[key]?.id}`}
                          placement="top"
                        >
                          <PopoverBody>{type === "AWS" ? typePopoverText[filteredResources[key]?.id]?.replace('AWS/', '') : type === "GCP" ? typePopoverText[filteredResources[key]?.id] : type === 'NewRelic' ? getNRDisplayName(filteredResources[key].resource_name)
                            : type === 'Azure' ? getAzureDisplayName(filteredResources[key].resource_name) : type === 'Splunk' ? getSplunkName(filteredResources[key].resource_name) : type === 'AppDynamics' ? getAppDynamicsName(filteredResources[key].resource_name)
                              : type === 'Dynatrace' ? getDynatraceName(filteredResources[key].resource_name)
                                : type === 'OCI' ? getOciName(filteredResources[key].resource_name)
                                  : type === 'Grafana' ? getGrafanaName(filteredResources[key].resource_name)
                                    : type === 'Signoz' ? getSignozName(filteredResources[key].resource_name)
                                      : getDatadogName(filteredResources[key].resource_name)}</PopoverBody>
                        </Popover>
                      </div>
                    </Col>
                    <Col md="2" className="padding-t-15">
                      <div className="mb-1 text-center">
                        <div
                          id={`env-link-${key}-${filteredResources[key]?.id}`}
                          onMouseEnter={() => handleEnvMouseEnter(filteredResources[key]?.id, filteredResources[key].environment)}
                          onMouseLeave={() => handleEnvMouseLeave(filteredResources[key]?.id)}
                          style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}
                        >
                          {filteredResources[key].environment || 'PRODUCTION'}
                        </div>
                        <Popover isOpen={environmentPopoverOpen[key] || false}
                                 target={document.getElementById(`env-link-${key}-${filteredResources[key]?.id}`) ? `env-link-${key}-${filteredResources[key]?.id}` : null}
                                 placement="top">
                          <PopoverBody>{environmentPopoverText}</PopoverBody>
                        </Popover>
                      </div>
                    </Col>

                    {type !== 'Datadog' && type !== 'NewRelic' && type !== 'Splunk' && type !== 'AppDynamics' && type !== 'Dynatrace' && type !== 'Grafana' && type !== 'Signoz' && (
                      <Col md="1" className="padding-t-15">
                        <div className="mb-1 text-center">
                          <div
                            id={`region-link-${key}-${filteredResources[key]?.id}`}
                            onMouseEnter={() => handleRegionMouseEnter(filteredResources[key]?.id)}
                            onMouseLeave={() => handleRegionMouseLeave(filteredResources[key]?.id)}
                            style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}
                          >
                            {type === "AWS" ? filteredResources[key]?.region : type === "GCP" ? filteredResources[key]?.region
                              : type === 'Azure' ? filteredResources[key]?.location?.replace(/\s+/g, '').toLowerCase() : filteredResources[key]?.region}
                          </div>
                          <Popover isOpen={regionPopoverOpen[key] || false}
                                   target={document.getElementById(`region-link-${key}-${filteredResources[key]?.id}`) ? `region-link-${key}-${filteredResources[key]?.id}` : null}
                                   placement="top">
                            <PopoverBody>{type === "AWS" ? filteredResources[key]?.region : type === "GCP" ? filteredResources[key]?.region
                              : type === 'Azure' ? filteredResources[key]?.location?.replace(/\s+/g, '').toLowerCase() : filteredResources[key]?.region}</PopoverBody>
                          </Popover>
                        </div>
                      </Col>
                    )}

                    <Col md={type !== 'NewRelic' && type !== 'Datadog' && type !== 'AppDynamics' && type !== 'Splunk' ? "1" && type !== 'Dynatrace' && type !== 'Grafana' : "2"}
                         className="padding-t-15">
                      {filteredResources[key].environment === 'PRODUCTION' ? (
                        <>
                          <div style={{display: 'flex', justifyContent: 'center', gap: '10px'}}>
                            <div>
                              <div>
                                {filteredResources[key].parent_resource_id !== null &&
                                  (filteredResources[key].resource_name === 'AWS/EC2' || filteredResources[key].resource_name === 'AWS/ECS/Instances') ?
                                  (<>
                                    <p className='text-center'>
                                      Ignored
                                      <span
                                        id="TooltipEC2"
                                        onMouseOver={() => setEc2IgnoredTooltip(true)}
                                        onMouseLeave={() => setEc2IgnoredTooltip(false)}
                                        className="alert-icon"
                                      >
                                        <i className="mdi mdi-information-outline text-warning"/>
                                    </span>
                                    </p>
                                    <Tooltip
                                      placement="right"
                                      isOpen={ec2IgnoredTooltip}
                                      target="TooltipEC2"
                                      toggle={() => {
                                        setEc2IgnoredTooltip(!ec2IgnoredTooltip);
                                      }}
                                      className="tooltip-component"
                                      style={{
                                        border: '2px solid #f1b44c',
                                        borderRadius: '10px',
                                        backgroundColor: '#2a3042',
                                      }}
                                    >
                                      {"Autoscaled EC2 instances excluded from ALCOM."}
                                    </Tooltip>
                                  </>) :
                                  (
                                    <>
                                      <div className="mb-2 text-center">
                                        {getMissingAlertsDisplay(
                                          filteredResources[key].alerts.length,
                                          filteredResources[key].missing_alerts.length
                                        )}
                                      </div>
                                      <div className="mb-2 text-center">
                                        {filteredResources[key].alerts.length} Set up
                                      </div>
                                    </>)
                                }
                              </div>
                            </div>
                            {filteredResources[key].resource_name === 'splunk_apm_inferred_service' ? (
                              <>
                                                                    <span
                                                                      id={`TooltipRight-${filteredResources[key]?.id}`}
                                                                      onMouseOver={() => handleRegionTooltipOpen(filteredResources[key]?.id)}
                                                                      onMouseLeave={() => handleRegionTooltipClose(filteredResources[key]?.id)}
                                                                      style={{
                                                                        marginLeft: '0px',
                                                                        alignSelf: 'center',
                                                                      }}
                                                                      className="alert-icon">
                                                                        <i className="mdi mdi-information-outline text-warning"/>
                                                                    </span>
                                <Tooltip
                                  placement="top"
                                  isOpen={regionTooltipOpen[filteredResources[key]?.id] || false}
                                  target={`TooltipRight-${filteredResources[key]?.id}`}
                                  toggle={() => {

                                  }}
                                  style={{
                                    border: "2px solid #f1b44c",
                                    borderRadius: "10px",
                                    backgroundColor: "#2a3042",
                                    zIndex: 1,
                                  }}>
                                  Splunk APM Inferred Service does not support Detectors
                                </Tooltip>
                              </>
                            ) : null}
                          </div>
                        </>
                      ) : (
                        <>
                          <p className='text-center'>
                            Ignored
                            <span
                              id="TooltipRight"
                              onMouseOver={() => settright(true)}
                              onMouseLeave={() => settright(false)}
                              className="alert-icon"
                            >
                                                            <i className="mdi mdi-information-outline text-warning"/>
                                                        </span>
                          </p>
                          <Tooltip
                            placement="right"
                            isOpen={tright}
                            target="TooltipRight"
                            toggle={() => {
                              settright(!tright);
                            }}
                            className="tooltip-component"
                            style={{
                              border: '2px solid #f1b44c',
                              borderRadius: '10px',
                              backgroundColor: '#2a3042',
                            }}
                          >
                            {"Alerts are analyzed only on production resources."}
                          </Tooltip>
                        </>
                      )}
                    </Col>
                    <Col md="2" className="padding-t-15">
                      <div className="mb-2 text-center">
                        {getNotificationServiceMapping(filteredResources[key])}
                      </div>
                    </Col>
                    <Col md="2" className="padding-t-15">
                      <div className="d-flex gap-3 justify-content-center">
                        <Link
                          to={
                            type === "AWS" ? `/resource/${filteredResources[key].id}/alerts` :
                              type === "GCP" ? `/gcp/resource/${filteredResources[key].id}/alerts` :
                                type === 'Azure' ? `/azure/resource/${filteredResources[key].id}/alerts` :
                                  type === 'AppDynamics' ? `/appdynamics/resource/${filteredResources[key].id}/alerts` :
                                    type === 'Datadog' ? `/datadog/resource/${filteredResources[key].id}/alerts` :
                                      type === 'Dynatrace' ? `/dynatrace/resource/${filteredResources[key].id}/alerts` :
                                        type === 'Splunk' ? `/splunk/resource/${filteredResources[key].id}/alerts` :
                                          type === 'OCI' ? `/oci/resource/${filteredResources[key]?.id}/alerts` :
                                            type === 'Grafana' ? `/grafana/resource/${filteredResources[key]?.id}/alerts` :
                                              type === 'Signoz' ? `/signoz/resource/${filteredResources[key]?.id}/alerts` :
                                                `/newrelic/resource/${filteredResources[key].id}/alerts`}
                          className="text-success">
                          <i className="mdi mdi-pencil font-size-24" id={`edittooltip-${index}`}/>
                          <UncontrolledTooltip className="tooltip-component" placement="top" target={`edittooltip-${index}`}>
                            Config Alerts
                          </UncontrolledTooltip>
                        </Link>
                        {filteredResources[key].environment === 'PRODUCTION' ? (
                          filteredResources[key].deployment_stage === 'deployment_required' ? (
                            <a href="#" onClick={(e) => {
                              e.preventDefault();
                              startLoading2();
                              handleIndividualDeploy(filteredResources[key].id);
                            }} id={`deploymenttooltip-${index}`}>
                              <i className="mdi mdi-cloud-sync font-size-24"/>
                              <UncontrolledTooltip className="tooltip-component" placement="top"
                                                   target={`deploymenttooltip-${index}`}>
                                Deploy Alerts
                              </UncontrolledTooltip>
                            </a>
                          ) : (
                            <Link to="#" className="text-success">
                              <i className="mdi mdi-cloud-check font-size-24"
                                 id={`deploymenttooltip-${index}`}/>
                              <UncontrolledTooltip className="tooltip-component" placement="top"
                                                   target={`deploymenttooltip-${index}`}>
                                In Sync
                              </UncontrolledTooltip>
                            </Link>
                          )
                        ) : (
                          <Link to="#" className="text-warning">
                            <i className="mdi mdi-cloud-off-outline font-size-24" id={`deploymenttooltip-${index}`}/>
                            <UncontrolledTooltip placement="top" target={`deploymenttooltip-${index}`}>
                              Deployments disabled for non-production resources
                            </UncontrolledTooltip>
                          </Link>
                        )}
                        {filteredResources[key].resource_name === "AWS/EKS" ? (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/cloud-resources?eks_cluster_id=${filteredResources[key].id}&eks_cluster_name=${filteredResources[key].name}`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Services
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        ) : filteredResources[key].resource_name === "AWS/AppSync" && filteredResources[key].parent_resource_id === null ? (
                          <>
                            <div style={{position: 'relative', right: 0}}>
                              <Link
                                to={`/cloud-resources-appsync-data-sources?appsync_id=${filteredResources[key].id}&data_type=datasource`}>
                                <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                  Data Sources
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                            <div style={{position: 'relative', right: 0}}>
                              <Link
                                to={`/cloud-resources-appsync-resolvers?appsync_id=${filteredResources[key].id}&data_type=resolvers`}>
                                <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-resolver-${index}`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-resolver-${index}`}>
                                  Resolvers
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                          </>) : filteredResources[key].resource_name === 'AWS/EC2' &&
                        JSON.parse(filteredResources[key].resource_metadata) &&
                        JSON.parse(filteredResources[key].resource_metadata).hasOwnProperty('cw_agent_installed') &&
                        JSON.parse(filteredResources[key].resource_metadata).hasOwnProperty('cw_agent_enabled') &&
                        JSON.parse(filteredResources[key].resource_metadata).cw_agent_enabled === true &&
                        JSON.parse(filteredResources[key].resource_metadata).cw_agent_installed === false ? (
                          <div id={`cw_agent_not_installed_${filteredResources[key]?.id}`}
                               onMouseEnter={() => handleMouseEnterIcon(key, 'CloudWatch Agent not installed')}
                               onMouseLeave={() => handleMouseLeaveIcon(key)}
                               style={{position: 'relative', right: 0}}>
                            <i className="mdi mdi-alert blinking-icon"/>
                            <Popover isOpen={iconPopoverOpen[key] || false}
                                     target={`cw_agent_not_installed_${filteredResources[key]?.id}`}
                                     placement="top">
                              <PopoverBody>{iconPopoverText}</PopoverBody>
                            </Popover>
                          </div>
                        ) : null}
                        {/* Additional Tooltip for Key Transactions */}
                        {getNRDisplayName(filteredResources[key].resource_name) === "APM" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/newrelic/resource/${filteredResources[key].id}/transactions`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Transactions
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {/* Additional Tooltip for External Services */}
                        {getNRDisplayName(filteredResources[key].resource_name) === "APM" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/new-relic-external-services?service_monitored_resource_id=${filteredResources[key].id}`}>
                              <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-${index}-external-service`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-external-service`}>
                                External Services
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getDatadogName(filteredResources[key].resource_name) === "APM Service" && filteredResources[key].parent_resource_id === null && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/datadog-service-dependency?service_monitored_resource_id=${filteredResources[key].id}`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Service Dependencies
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getDatadogName(filteredResources[key].resource_name) === "APM Service" && filteredResources[key].parent_resource_id === null && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/datadog/api-endpoints?service_monitored_resource_id=${filteredResources[key].id}`}>
                              <i className="mdi mdi-api font-size-24" id={`additionaltooltipApiEndpoints-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltipApiEndpoints-${index}`}>
                                API Endpoints
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getSplunkName(filteredResources[key].resource_name) === "APM Service" && filteredResources[key].parent_resource_id === null && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/splunk-service-dependency?service_monitored_resource_id=${filteredResources[key].id}`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Service Dependencies
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getSplunkName(filteredResources[key].resource_name) === "APM Service" && filteredResources[key].parent_resource_id === null && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/splunk-service-dependency?service_monitored_resource_id=${filteredResources[key].id}&service_type=splunk_apm_endpoint`}>
                              <i className="mdi mdi-api font-size-24" id={`additionaltooltipApiEndpoints-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltipApiEndpoints-${index}`}>
                                API Endpoints
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getAppDynamicsName(filteredResources[key].resource_name) === "Application" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/appdynamics/resource/${filteredResources[key].id}/transactions`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Transactions
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {/* Additional Tooltip for External Services */}
                        {getAppDynamicsName(filteredResources[key].resource_name) === "Application" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link
                              to={`/appdynamics-external-services?parent_resource_id=${filteredResources[key].id}&parent_resource_name=${filteredResources[key].name}`}>
                              <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-${index}-external-service`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-external-service`}>
                                External Services
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getGrafanaName(filteredResources[key]?.master_resource_name) === "APM" && (
                            <div style={{position: 'relative', right: 0}}>
                              <Link to={`/grafana/resource/${filteredResources[key].id}/transactions`}>
                                <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                  Transactions
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                        )}
                        {getGrafanaName(filteredResources[key]?.master_resource_name) === "APM" && (
                            <div style={{position: 'relative', right: 0}}>
                              <Link
                                  to={`/grafana-external-services?parent_resource_id=${filteredResources[key].id}&parent_resource_name=${filteredResources[key].name}`}>
                                <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-${index}-external-service`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-external-service`}>
                                  External Services
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                        )}
                        {getSignozName(filteredResources[key]?.master_resource_name) === "APM" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link to={`/signoz/resource/${filteredResources[key].id}/transactions`}>
                              <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}`}>
                                Transactions
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getSignozName(filteredResources[key]?.master_resource_name) === "APM" && (
                          <div style={{position: 'relative', right: 0}}>
                            <Link
                              to={`/signoz-external-services?parent_resource_id=${filteredResources[key].id}&parent_resource_name=${filteredResources[key].name}`}>
                              <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-${index}-external-service`}/>
                              <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-external-service`}>
                                External Services
                              </UncontrolledTooltip>
                            </Link>
                          </div>
                        )}
                        {getDynatraceName(filteredResources[key].resource_name) === "Applications" && (
                          <>
                            <div style={{position: 'relative', right: 0}}>
                              <Link
                                to={`/dynatrace-key-user-actions?parent_resource_id=${filteredResources[key].id}&parent_resource_name=${filteredResources[key].name}`}>
                                <i className="mdi mdi-transition font-size-24" id={`additionaltooltip-${index}-key-user-actions`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-key-user-actions`}>
                                  Key User Actions
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                            <div style={{position: 'relative', right: 0}}>
                              <Link
                                to={`/dynatrace-user-actions?parent_resource_id=${filteredResources[key].id}&parent_resource_name=${filteredResources[key].name}`}>
                                <i className="mdi mdi-transit-detour font-size-24" id={`additionaltooltip-${index}-external-service`}/>
                                <UncontrolledTooltip placement="top" target={`additionaltooltip-${index}-external-service`}>
                                  User Actions
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </CardItem>
            ))
          ))}
      </div>
      <h6 style={{textAlign: 'right', marginTop: '5px'}}>Showing {resourceCount} of {total_resources} Results</h6>
    </div>
  );
};

export default TableRow;